<style lang="scss" scoped>
.dropbtn {
  font-size: 30px;
  border: none;
  cursor: pointer;
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
}

.dropdown {
  position: relative;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.dropdown-content {
  display: none;
  position: absolute;
  left: -80px;
  background-color: var(--color-user-menu-background);
  border: 1px solid var(--color-user-menu-background);
  width: 220px;
  z-index: 100;
  margin-right: 10px;
  border-radius: 5px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  overflow: hidden;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.invert {
  filter: invert(1);
}

.nickname {
  background: linear-gradient(
    to bottom left,
    var(--color-accent-dark),
    var(--color-accent)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.menu {
  .row {
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;

    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 60px;
    }

    .icon {
      fill: var(--color-text);

      &.stroke {
        stroke: var(--color-text);
        fill: 'none';
      }
    }

    .label {
      flex: auto;
      text-align: left;
    }

    &.exit {
      display: none;

      @media screen and (max-width: 430px) {
        display: flex;
      }
    }

    &:hover {
      background-color: var(--color-user-menu-card);
    }
  }
}

.social-list {
  display: flex;
  height: 55px;

  .column {
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      fill: var(--color-text-dark);
    }

    &:hover {
      background-color: var(--color-user-menu-card-dark);

      .icon {
        fill: var(--color-text);
      }
    }

    // tooltip fix
    & ::v-deep .ivu-tooltip-rel {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>

<template>
  <div>
    <div class="dropdown">
      <div class="dropbtn">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="32"
          viewBox="0 0 1535 1706"
          fill="none"
        >
          <g clip-path="url(#clip0_434_20)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1235 489.5C1235 735.543 1035.54 935 789.5 935C543.457 935 344 735.543 344 489.5C344 243.457 543.457 44 789.5 44C1035.54 44 1235 243.457 1235 489.5ZM1095.08 869.358C1011.49 936.694 905.2 977 789.5 977C703.695 977 623.068 954.832 553.033 915.911C606.698 959.889 674.634 996.995 750.042 1009.2C851.679 1025.65 971.788 997.689 1095.08 869.358ZM1247.59 656.642C1266.62 604.509 1277 548.217 1277 489.5C1277 220.261 1058.74 2 789.5 2C520.261 2 302 220.261 302 489.5C302 538.869 309.338 586.523 322.984 631.432C237.909 690.994 95.3654 844.114 108.188 1059.26C21.6442 1217.78 -2.5 1332.85 -2.5 1376.5V1381.13L-1.10378 1385.55C35.359 1500.85 236.507 1701.18 734.439 1710.49C979.225 1715.07 1157.84 1679.79 1282.67 1632.26L1284.4 1634.79C1286.98 1633.03 1289.03 1631.07 1290.64 1629.18C1413.85 1580.86 1485.41 1519.69 1512.9 1472.63L1513.89 1470.95L1514.64 1469.16C1530.66 1431.2 1535.71 1378.29 1530.56 1321.2C1525.35 1263.45 1509.46 1198.63 1480.89 1135.56C1473.29 1118.78 1464.77 1102.09 1455.29 1085.66L1455.42 1085.67C1470.85 872.901 1334.02 719.884 1247.59 656.642ZM1297.36 1561.43C1393.11 1519.27 1442.69 1472.4 1460.11 1444.02C1470.34 1418.41 1475.37 1377.24 1470.8 1326.59C1466.18 1275.4 1451.98 1217.14 1426.24 1160.32C1376.69 1050.94 1285.5 948.801 1139.39 909.838C1003.8 1051.49 864.22 1088.46 740.458 1068.43C621.157 1049.12 521.259 977.646 457.129 907.583C388.232 908.578 255.991 920.898 174.051 1064.38C83.1593 1223.53 59.512 1335.01 57.6265 1371.93C73.6289 1415.92 129.929 1489.98 251.844 1550.74C253.981 1538.66 256.796 1525.09 260.037 1511.1C269.527 1470.14 283.692 1421.17 297.458 1392.51L351.541 1418.49C340.808 1440.83 327.823 1484.36 318.488 1524.65C313.898 1544.46 310.445 1562.39 308.676 1575.35C308.646 1575.57 308.618 1575.78 308.59 1575.99C411.181 1616.67 550.276 1647.04 735.561 1650.51C959.484 1654.69 1123.65 1624.6 1239.19 1584.26C1238.24 1570.19 1235.91 1550.94 1232.34 1529.8C1224.91 1485.72 1213.05 1439.28 1200.09 1415.24L1252.91 1386.76C1270.94 1420.22 1283.99 1475.28 1291.51 1519.82C1293.99 1534.55 1295.97 1548.74 1297.36 1561.43ZM1222.81 713.094C1197.34 762.364 1163.71 806.733 1123.71 844.415L1136.16 847.248C1246.98 872.465 1331.16 928.967 1392.74 998.478C1373.49 863.559 1286.43 763.093 1222.81 713.094ZM173.658 963.22C197.359 833.147 283.304 736.917 344.884 689.724C371.979 749.799 410.893 803.397 458.66 847.556C396.762 848.235 271.176 856.935 173.658 963.22Z"
              :fill="$store.getters.isThemeLight ? 'var(--color-text-light)' : 'var(--color-neutral-light)'"
            />
            <path
              d="M592.5 315.5C470 315.5 383.353 444.5 420.5 527C438.286 566.5 516.5 630.444 613.501 652C710.501 673.556 884.834 665.333 942 652C999.167 638.667 1107.6 603.7 1150 536.5C1192.4 469.3 1141 394.167 1109 365C1092.5 348.5 1044.3 315.5 991.5 315.5H592.5Z"
              fill="url(#paint0_linear_434_20)"
              stroke="var(--color-text)"
              stroke-width="42"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_434_20"
              x1="412"
              y1="490"
              x2="1166"
              y2="490"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="var(--color-accent)" />
              <stop
                offset="1"
                stop-color="var(--color-accent-light)"
              />
            </linearGradient>
            <clipPath id="clip0_434_20">
              <rect
                width="1535"
                height="1706"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
        <Icon
          style="margin-top: 5px; margin-bottom: 5px; color: var(--color-neutral)"
          size="15"
          type="ios-arrow-down"
        />
      </div>
      <div class="dropdown-content">
        <!--        <div class="version" style="font-weight: bold; padding-top: 10px; color: #404364;">-->
        <!--          версия 19.2-->
        <!--        </div>-->
        <div
          class="nickname"
          style="margin: 15px; margin-bottom: 12px; text-align: center; color: #633cfc"
        >{{nickname}}</div>
        <!--        <div style="margin: 15px; text-align: center;">-->
        <!--          Демо &nbsp;-->
        <!--          <i-switch :value="demoEnabled" @on-change='demoChanged' style="margin-bottom: 2px;"></i-switch>-->
        <!--        </div>-->
        <div style="margin-bottom: 12px;">
          <RadioGroup
            type="button"
            size="small"
            v-model="$store.state.sys.lang"
            @on-change="changeLanguage"
          >
            <Radio
              label="ru"
              style="width: 60px; text-align: center; padding-top: 2px"
            >
              <img
                src="../../../assets/russia-flag.png"
                width="55%"
              >
            </Radio>
            <Radio
              label="en"
              style="width: 60px; text-align: center; padding-top: 2px"
            >
              <img
                src="../../../assets/united-states-flag.png"
                width="55%"
              >
            </Radio>
            <Radio
              label="es"
              style="width: 60px; text-align: center; padding-top: 2px"
            >
              <img
                src="../../../assets/spain-flag.png"
                width="55%"
              >
            </Radio>
          </RadioGroup>
        </div>
        <div style="text-align: center">
          <div>{{ $text.tr('Стоимость') }}</div>
          <RadioGroup
            type="button"
            size="small"
            v-model="$store.state.sys.usdbtc"
          >
            <Radio
              label="USD"
              style="font-size: 10pt; width: 60px; text-align: center;"
              size="small"
            >USD</Radio>
            <Radio
              label="BTC"
              style="font-size: 10pt; width: 60px; text-align: center;"
              size="small"
            >BTC</Radio>
          </RadioGroup>
        </div>
        <div style="margin-top: 10px; height: 50px; display: flex; align-items: center; justify-content: center">
          <i-switch
            size="small"
            v-model='$store.state.sys.hideBalances'
            @on-change="hideBalancesChanged"
          ></i-switch>
          <div style="margin-left: 10px">{{ $text.tr('Скрыть балансы') }}</div>
        </div>
        <div class="menu">
          <div
            v-for="item in menuItems"
            :key="item.label"
            :class="['row', item.class]"
            @click="selectMenuItem(item.id)"
          >
            <div class="icon-wrapper">
              <svg
                :width="(item.width || 24) + 'px'"
                :height="(item.height || 24) + 'px'"
                :class="['icon', item.isStroke && 'stroke']"
              >
                <use :href="item.icon + '#svg'"></use>
              </svg>
            </div>
            <div class="label">
              <span>{{ $text.tr(item.label) }}</span>
              <template v-if="item.extraLabel">
                <br />
                <span>{{ $text.tr(item.extraLabel) }}</span>
              </template>
            </div>
          </div>
        </div>
        <div class="social-list">
          <a
            :href="$text.tr('https://t.me/capico_chat_ru')"
            target="_blank"
            title="telegram"
            class="column"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              class="icon"
            >
              <path d="m12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12c0-6.627-5.373-12-12-12zm5.894 8.221-1.97 9.28c-.145.658-.537.818-1.084.508l-3-2.21-1.446 1.394c-.14.18-.357.295-.6.295-.002 0-.003 0-.005 0l.213-3.054 5.56-5.022c.24-.213-.054-.334-.373-.121l-6.869 4.326-2.96-.924c-.64-.203-.658-.64.135-.954l11.566-4.458c.538-.196 1.006.128.832.941z" />
            </svg>
          </a>
          <a
            :href="$text.tr('https://twitter.com/capico_ru')"
            target="_blank"
            title="twitter"
            class="column"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              class="icon"
            >
            <path fill-rule="evenodd" clip-rule="evenodd" d="M 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 Z M 10.644531 12.59375 L 5.9375 6.296875 L 9.554688 6.296875 L 12.640625 10.425781 L 16.457031 6.296875 L 17.515625 6.296875 L 13.121094 11.050781 L 18.078125 17.703125 L 14.464844 17.703125 L 11.113281 13.214844 L 6.96875 17.703125 L 5.910156 17.703125 Z M 9.164062 7.074219 L 7.496094 7.074219 L 14.851562 16.910156 L 16.519531 16.910156 Z M 9.164062 7.074219 "/>
            </svg>
          </a>
          <a
            href="mailto:support@capico.app"
            class="column"
          >
            <Tooltip
              placement="top-end"
              content="support@capico.app"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="icon"
              >
                <path d="M11.9998 0C5.37257 0 0 5.37264 0 11.9998C0 18.6267 5.37257 23.9998 11.9998 23.9998C18.627 23.9998 24 18.6267 24 11.9998C24 5.37264 18.627 0 11.9998 0ZM12 4.21488L19.1012 8.64288H4.89888L12 4.21488ZM19.1897 15.7138H19.189C19.189 16.4241 18.6133 16.9996 17.9032 16.9996H6.0969C5.38665 16.9996 4.81112 16.424 4.81112 15.7138V8.92464C4.81112 8.84952 4.8188 8.77648 4.83128 8.70472L11.616 12.9354C11.6244 12.9406 11.6332 12.9441 11.6418 12.9489C11.6508 12.9538 11.6599 12.9586 11.669 12.9632C11.7169 12.9879 11.7663 13.0078 11.8168 13.0209C11.822 13.0223 11.8272 13.023 11.8324 13.0242C11.8877 13.0372 11.9438 13.0454 11.9998 13.0454H12.0002C12.0006 13.0454 12.001 13.0454 12.001 13.0454C12.057 13.0454 12.1131 13.0374 12.1684 13.0242C12.1736 13.0229 12.1788 13.0223 12.184 13.0209C12.2344 13.0078 12.2836 12.9879 12.3318 12.9632C12.3409 12.9586 12.35 12.9538 12.359 12.9489C12.3675 12.9441 12.3764 12.9406 12.3848 12.9354L19.1695 8.70472C19.182 8.77648 19.1897 8.84936 19.1897 8.92464V15.7138Z" />
              </svg>
            </Tooltip>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/util/api'
import Util from '@/util/util'

export default {
  name: 'Dropdown',
  data () {
    return {
      demoEnabled: true,
      menuItems: [
        {
          id: 'video',
          icon: require('@/assets/dropdown/video.svg'),
          width: '24',
          height: '20',
          label: 'Видео',
          isStroke: true
        },
        {
          id: 'knowbase',
          icon: require('@/assets/dropdown/knowbase.svg'),
          width: '18',
          height: '22',
          label: 'База знаний',
          isStroke: true
        },
        {
          id: 'pay',
          icon: require('@/assets/dropdown/pay.svg'),
          width: '22',
          height: '18',
          label: 'Оплата'
        },
        {
          id: 'refcab',
          icon: require('@/assets/dropdown/refcab.svg'),
          width: '22',
          height: '18',
          label: 'Реферальный',
          extraLabel: 'кабинет'
        },
        {
          id: 'settings',
          icon: require('@/assets/dropdown/settings.svg'),
          width: '22',
          height: '22',
          label: 'Настройки'
        },
        {
          id: 'exit',
          icon: require('@/assets/dropdown/exit.svg'),
          class: 'exit',
          width: '22',
          height: '22',
          label: 'Выход'
        }
      ]
    }
  },
  created () {
    this.demoEnabled = this.$store.getters.demoState
  },
  computed: {
    nickname () {
      const partsOfStr = this.$store.state.sys.email.split('@')
      if (partsOfStr.length > 1) {
        return partsOfStr[0]
      }
      return ''
    }
  },
  methods: {
    hideBalancesChanged () {
      localStorage.setItem(
        'capico_app_hide_balances',
        this.$store.state.sys.hideBalances
      )
    },
    changeLanguage () {
      const ref = this
      Api.get('user/changelang', {
        params: {
          token: this.$store.state.sys.token,
          lang: this.$store.state.sys.lang
        }
      })
        .then(response => {
          if (response.data !== null) {
            if (response.data.err) {
              ref.$Notice.error({
                title: ref.$text.tr('Ошибка'),
                desc: Util.returnTextForErr(response.data.err),
                duration: 10
              })
            } else {
              // console.log('language changed')
              localStorage.setItem('capico_app_lang', ref.$store.state.sys.lang)
              ref.$router.go(0)
            }
          }
        })
        .catch(error => {
          console.log(error)
          ref.$Notice.error({
            title: ref.$text.tr('Ошибка'),
            desc: Util.returnTextForErr(response.data.err),
            duration: 10
          })
        })
    },
    selectMenuItem (item) {
      switch (item) {
        case 'video':
          window.open(
            this.$text.tr('https://www.youtube.com/channel/UCTiUrt0gbkhC-fuY6-Y_3Ng'),
            '_blank'
          )
          break
        case 'knowbase':
          window.open(this.$text.tr('https://doc.capico.app/v/ru/'), '_blank')
          break
        case 'exit':
          this.$store.state.sys.tradeExchange = {}
          this.$store.state.sys.token = ''
          this.$store.state.trade.editTrade = null
          localStorage.removeItem('token')
          this.$router.push('/login')
          break
        default:
          this.$router.push('/' + item)
          break
      }
    },
    demoChanged (demoEnabledState) {
      if (demoEnabledState) {
        this.$store.state.assets.allexchs = false
      }
      this.demoEnabled = demoEnabledState
      this.$store.commit('setDemoState', demoEnabledState)
      this.$store.dispatch('updateExchanges')
    }
  }
}
</script>
